import { useEffect, useState } from 'react';
import { useId } from '@fluentui/react-hooks';
import { TextField, Callout, FontWeights, Text, DirectionalHint, PrimaryButton, makeStyles } from '@fluentui/react';

interface ApproverCommentCellProps {
    labelText: string;
    defaultValue: string;
    onUpdated: (value: string) => void;
    reportPeriodId: string;
    disabled: boolean;
    commentDisabled: boolean;
}

function ApproverCommentCell(props: ApproverCommentCellProps) {
    const styles = getStyles();
    const targetId = useId();

    const [showdetailsflyout, setShowdetailsflyout] = useState<boolean>(false);
    const [cellComment, setCellComment] = useState<string>(props.defaultValue ?? '');

    useEffect(() => {
        setCellComment(props.defaultValue);
    }, []);

    return (
        <>
            <div className="periodComment">
                <PrimaryButton
                    id={targetId}
                    style={{ color: 'white', minWidth: 50, width: 50 }}
                    iconProps={{ iconName: 'Comment' }}
                    className="periodCommentIcon"
                    onClick={() => {
                        setShowdetailsflyout(true);
                    }}
                    disabled={props.disabled || (props.commentDisabled && (cellComment == '' || cellComment == undefined || cellComment == null))}
                />
            </div>
            {showdetailsflyout && (
                <Callout
                    target={`#${targetId}`}
                    className={styles.callout}
                    ariaLabelledBy="{labelId}"
                    ariaDescribedBy="{descriptionId}"
                    role="alertdialog"
                    gapSpace={0}
                    directionalHint={DirectionalHint.leftBottomEdge}
                    onDismiss={() => {
                        setShowdetailsflyout(false);
                        if (!props.commentDisabled) {
                            props.onUpdated(cellComment);
                        }
                    }}
                    setInitialFocus
                    dismissOnTargetClick={true}
                >
                    <div className={styles.header}>
                        <Text className={styles.title}>{props.labelText}</Text>
                    </div>
                    <div className={styles.inner}>
                        <TextField
                            value={cellComment}
                            disabled={props.commentDisabled}
                            onChange={
                                props.commentDisabled
                                    ? () => {}
                                    : (e, v) => {
                                          setCellComment(v);
                                      }
                            }
                            multiline
                            autoAdjustHeight
                        />
                    </div>
                </Callout>
            )}
        </>
    );
}

export default ApproverCommentCell;

const getStyles = makeStyles(theme => ({
    callout: {
        maxWidth: 800,
        minWidth: 300,
    },
    header: {
        padding: '18px 24px 12px',
        color: theme.semanticColors.bodyText,
    },
    title: [
        theme.fonts.mediumPlus,
        {
            margin: 0,
            fontWeight: FontWeights.semilight,
        },
    ],
    inner: {
        height: '100%',
        padding: '0 24px 20px',
    },
}));
